import { CSSProperties } from '@material-ui/styles'

export const AutoCompleteStyle: CSSProperties = {
	maxHeight: '60vh',
	overflowY: 'scroll'
}
